const QueryObjects = () => {
  return (
    <div>
      <h1>Welcome QueryObjects</h1>
    </div>
  );
};
export { QueryObjects };
